export const SHOW_CONVERSION_MODAL = 'SHOW_CONVERSION_MODAL';
export const HIDE_CONVERSION_MODAL = 'HIDE_CONVERSION_MODAL';
